import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { jwtParser } from '../../utils/utilities';
import storage from '../../api/localStorage';
import MainLayout from '../../core-components/Layout/MainLayout';

export default ({ component: Component, redirect = '/login', onlyAdmin = false, ...rest }) => {
  const token = storage.getToken();
  const parsedJwtDetail = jwtParser(token);

  if (rest.location.pathname === '/company/bgv') {
    if (storage.getToken() !== storage.getBGVToken()) {
      storage.setBGVTokenChange('true');
    } else {
      storage.setBGVTokenChange('false');
    }
  }
  if (
    (rest.location.pathname === '/credits' ||
      rest.location.pathname === '/purchaseHistory' ||
      rest.location.pathname === '/transaction') &&
    parsedJwtDetail?.data?.modelType?.includes('POSTPAID')
  ) {
    return <Redirect to={{ pathname: '/dashboard' }} />;
  }

  const getComponentLayout = (props) => {
    if (
      rest.path == '/candidate/report' ||
      rest.path == '/candidate/resume' ||
      rest.path === '/candidate/consent-letter' ||
      rest.path === '/candidate/document' ||
      rest.path === '/unauthorized' ||
      rest.path === '/company/bgv' ||
      rest.path === '/invoice' ||
      rest.path === '/proforma-invoice'
    ) {
      return <Component {...props} />;
    } else {
      return (
        <MainLayout>
          <Component {...props} />
        </MainLayout>
      );
    }
  };
  const isNonLoggedInPage = (props) => {
    if (rest.path === '/purchase/payment-request') {
      return getComponentLayout(props)
    } else {
      return <Redirect to={{ pathname: redirect, state: { from: props.location } }} />
    }
  }
  return (
    <Route
      {...rest}
      render={(props) =>
        storage.getToken() ? (
          onlyAdmin ? (
            storage.getAccessLevel() === 'admin' ? (
              rest.render ? (
                rest.render(props)
              ) : (
                getComponentLayout(props)
              )
            ) : (
              <Redirect to={{ pathname: '/dashboard', state: { from: props.location } }} />
            )
          ) : rest.render ? (
            rest.render(props)
          ) : (
            getComponentLayout(props)
          )
        ) : isNonLoggedInPage(props)
      }
    />
  );
};
